// Auto-generated by scripts/sync-rounds.mjs - do not edit directly.
export type SplashScene = {
  publicId: string;
  title: string;
  dateLabel: string;
  year: number;
  era: "ancient" | "medieval" | "early-modern" | "modern";
  continent: "Africa" | "Antarctica" | "Asia" | "Europe" | "North America" | "Oceania" | "South America";
  url: string;
};

export const SPLASH_SCENES: SplashScene[] = [
  {
    "publicId": "0c9258c1afd337500639aa18",
    "title": "Great Pyramid Construction",
    "dateLabel": "2560 BCE",
    "year": -2560,
    "era": "ancient",
    "continent": "Africa",
    "url": "/panoramas/0c9258c1afd337500639aa18.webp"
  },
  {
    "publicId": "7cf0206494df110859603280",
    "title": "Stonehenge Final Phase",
    "dateLabel": "2500 BCE",
    "year": -2500,
    "era": "ancient",
    "continent": "Europe",
    "url": "/panoramas/7cf0206494df110859603280.webp"
  },
  {
    "publicId": "3991bc40dd6f476da5436d7b",
    "title": "Ishtar Gate of Babylon",
    "dateLabel": "575 BCE",
    "year": -575,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/3991bc40dd6f476da5436d7b.webp"
  },
  {
    "publicId": "9241c3dd79a235dc0a2e7499",
    "title": "Pharos of Alexandria",
    "dateLabel": "280 BCE",
    "year": -280,
    "era": "ancient",
    "continent": "Africa",
    "url": "/panoramas/9241c3dd79a235dc0a2e7499.webp"
  },
  {
    "publicId": "d84be71b8e10f68a7cbdd75b",
    "title": "Library of Alexandria",
    "dateLabel": "240 BCE",
    "year": -240,
    "era": "ancient",
    "continent": "Africa",
    "url": "/panoramas/d84be71b8e10f68a7cbdd75b.webp"
  },
  {
    "publicId": "bcb66b1013685cf584e0c6af",
    "title": "Terracotta Army Workshop",
    "dateLabel": "210 BCE",
    "year": -210,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/bcb66b1013685cf584e0c6af.webp"
  },
  {
    "publicId": "3186b56092ced9a0a032b07e",
    "title": "Caesar's Funeral in the Forum",
    "dateLabel": "44 BCE",
    "year": -44,
    "era": "ancient",
    "continent": "Europe",
    "url": "/panoramas/3186b56092ced9a0a032b07e.webp"
  },
  {
    "publicId": "678e202f5bb131fb8de8c560",
    "title": "Opening of the Colosseum",
    "dateLabel": "80 CE",
    "year": 80,
    "era": "ancient",
    "continent": "Europe",
    "url": "/panoramas/678e202f5bb131fb8de8c560.webp"
  },
  {
    "publicId": "5daf87590533df7ac2329b90",
    "title": "Building Hadrian's Wall",
    "dateLabel": "122 CE",
    "year": 122,
    "era": "ancient",
    "continent": "Europe",
    "url": "/panoramas/5daf87590533df7ac2329b90.webp"
  },
  {
    "publicId": "39d473cc67fb67650801948e",
    "title": "Avenue of the Dead",
    "dateLabel": "250 CE",
    "year": 250,
    "era": "ancient",
    "continent": "North America",
    "url": "/panoramas/39d473cc67fb67650801948e.webp"
  },
  {
    "publicId": "0b0a1122cc632a01c089115e",
    "title": "Constantinople Inaugurated",
    "dateLabel": "330 CE",
    "year": 330,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/0b0a1122cc632a01c089115e.webp"
  },
  {
    "publicId": "09baba9f6842116773eac07a",
    "title": "Ajanta Cave Painting",
    "dateLabel": "475 CE",
    "year": 475,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/09baba9f6842116773eac07a.webp"
  },
  {
    "publicId": "d6ba4d16316b4b66efd0565a",
    "title": "Hagia Sophia Completed",
    "dateLabel": "537 CE",
    "year": 537,
    "era": "medieval",
    "continent": "Asia",
    "url": "/panoramas/d6ba4d16316b4b66efd0565a.webp"
  },
  {
    "publicId": "d31512acab3f16734e45fc03",
    "title": "House of Wisdom",
    "dateLabel": "830 CE",
    "year": 830,
    "era": "medieval",
    "continent": "Asia",
    "url": "/panoramas/d31512acab3f16734e45fc03.webp"
  },
  {
    "publicId": "7ca9b29cababea78ccdde6f6",
    "title": "Angkor Wat Construction",
    "dateLabel": "1150 CE",
    "year": 1150,
    "era": "medieval",
    "continent": "Asia",
    "url": "/panoramas/7ca9b29cababea78ccdde6f6.webp"
  },
  {
    "publicId": "0aed70f2b1537e7be68ba95f",
    "title": "Notre-Dame Construction Begins",
    "dateLabel": "1163 CE",
    "year": 1163,
    "era": "medieval",
    "continent": "Europe",
    "url": "/panoramas/0aed70f2b1537e7be68ba95f.webp"
  },
  {
    "publicId": "e0c018303b310124d2f2027e",
    "title": "Great Zimbabwe",
    "dateLabel": "1250 CE",
    "year": 1250,
    "era": "medieval",
    "continent": "Africa",
    "url": "/panoramas/e0c018303b310124d2f2027e.webp"
  },
  {
    "publicId": "2e6b00676614fcffcf4e7612",
    "title": "Siege of Baghdad",
    "dateLabel": "1258 CE",
    "year": 1258,
    "era": "medieval",
    "continent": "Asia",
    "url": "/panoramas/2e6b00676614fcffcf4e7612.webp"
  },
  {
    "publicId": "37e9d9536d14898bf786a90e",
    "title": "Sankore Scholars",
    "dateLabel": "1325 CE",
    "year": 1325,
    "era": "medieval",
    "continent": "Africa",
    "url": "/panoramas/37e9d9536d14898bf786a90e.webp"
  },
  {
    "publicId": "82bbdecfb9f989ebe9928e04",
    "title": "Black Death in London",
    "dateLabel": "1349 CE",
    "year": 1349,
    "era": "medieval",
    "continent": "Europe",
    "url": "/panoramas/82bbdecfb9f989ebe9928e04.webp"
  },
  {
    "publicId": "e91b1bdbafa238c7ae68c0b6",
    "title": "Machu Picchu Built",
    "dateLabel": "1450 CE",
    "year": 1450,
    "era": "medieval",
    "continent": "South America",
    "url": "/panoramas/e91b1bdbafa238c7ae68c0b6.webp"
  },
  {
    "publicId": "ed2972fb3fc2c9a6e47cbfb7",
    "title": "Fall of Constantinople",
    "dateLabel": "1453 CE",
    "year": 1453,
    "era": "medieval",
    "continent": "Asia",
    "url": "/panoramas/ed2972fb3fc2c9a6e47cbfb7.webp"
  },
  {
    "publicId": "cd4404b17da28f883aa1c0b6",
    "title": "Gutenberg's Workshop",
    "dateLabel": "1455 CE",
    "year": 1455,
    "era": "medieval",
    "continent": "Europe",
    "url": "/panoramas/cd4404b17da28f883aa1c0b6.webp"
  },
  {
    "publicId": "f5173f71c1a7592d21f8f218",
    "title": "Columbus Reaches the Bahamas",
    "dateLabel": "1492 CE",
    "year": 1492,
    "era": "medieval",
    "continent": "North America",
    "url": "/panoramas/f5173f71c1a7592d21f8f218.webp"
  },
  {
    "publicId": "c5b1406899b4834c330efa1e",
    "title": "Tlatelolco Market",
    "dateLabel": "1519 CE",
    "year": 1519,
    "era": "early-modern",
    "continent": "North America",
    "url": "/panoramas/c5b1406899b4834c330efa1e.webp"
  },
  {
    "publicId": "f9d091b2218d83147606b552",
    "title": "Jamestown Settlement",
    "dateLabel": "1607 CE",
    "year": 1607,
    "era": "early-modern",
    "continent": "North America",
    "url": "/panoramas/f9d091b2218d83147606b552.webp"
  },
  {
    "publicId": "60945ede555dcd6bca6c1ea8",
    "title": "Galileo Demonstrates the Telescope",
    "dateLabel": "1609 CE",
    "year": 1609,
    "era": "early-modern",
    "continent": "Europe",
    "url": "/panoramas/60945ede555dcd6bca6c1ea8.webp"
  },
  {
    "publicId": "9c947c05147aaef5d7b573f4",
    "title": "The Globe Theatre Opens",
    "dateLabel": "1599 CE",
    "year": 1599,
    "era": "early-modern",
    "continent": "Europe",
    "url": "/panoramas/9c947c05147aaef5d7b573f4.webp"
  },
  {
    "publicId": "8a100ddd5eca30a95488b441",
    "title": "Akbar's Court at Fatehpur Sikri",
    "dateLabel": "1575 CE",
    "year": 1575,
    "era": "early-modern",
    "continent": "Asia",
    "url": "/panoramas/8a100ddd5eca30a95488b441.webp"
  },
  {
    "publicId": "36ce4273aa6f69e2bd35aa14",
    "title": "Batavia Harbor",
    "dateLabel": "1621 CE",
    "year": 1621,
    "era": "early-modern",
    "continent": "Asia",
    "url": "/panoramas/36ce4273aa6f69e2bd35aa14.webp"
  },
  {
    "publicId": "fd7a666d8f141f649465ca8b",
    "title": "Great Fire of London",
    "dateLabel": "1666 CE",
    "year": 1666,
    "era": "early-modern",
    "continent": "Europe",
    "url": "/panoramas/fd7a666d8f141f649465ca8b.webp"
  },
  {
    "publicId": "13c05263c818ade671d74d06",
    "title": "Versailles Becomes the Court",
    "dateLabel": "1682 CE",
    "year": 1682,
    "era": "early-modern",
    "continent": "Europe",
    "url": "/panoramas/13c05263c818ade671d74d06.webp"
  },
  {
    "publicId": "e56cf32e101d51d35b7ad7ca",
    "title": "Nihonbashi in Edo",
    "dateLabel": "1700 CE",
    "year": 1700,
    "era": "early-modern",
    "continent": "Asia",
    "url": "/panoramas/e56cf32e101d51d35b7ad7ca.webp"
  },
  {
    "publicId": "f975b7b6d046bc9c8bc88a7a",
    "title": "Boston Tea Party",
    "dateLabel": "1773 CE",
    "year": 1773,
    "era": "early-modern",
    "continent": "North America",
    "url": "/panoramas/f975b7b6d046bc9c8bc88a7a.webp"
  },
  {
    "publicId": "75a4a9a823afeb49946cda3d",
    "title": "Cook Arrives in Hawaiʻi",
    "dateLabel": "1778 CE",
    "year": 1778,
    "era": "early-modern",
    "continent": "North America",
    "url": "/panoramas/75a4a9a823afeb49946cda3d.webp"
  },
  {
    "publicId": "8fe2e30eda26f5cf8752ce00",
    "title": "Storming of the Bastille",
    "dateLabel": "1789 CE",
    "year": 1789,
    "era": "early-modern",
    "continent": "Europe",
    "url": "/panoramas/8fe2e30eda26f5cf8752ce00.webp"
  },
  {
    "publicId": "fded909ebe384e23caee1573",
    "title": "Battle of Trafalgar",
    "dateLabel": "1805 CE",
    "year": 1805,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/fded909ebe384e23caee1573.webp"
  },
  {
    "publicId": "c7de157cf06d73d36dd556e1",
    "title": "Opening of the Erie Canal",
    "dateLabel": "1825 CE",
    "year": 1825,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/c7de157cf06d73d36dd556e1.webp"
  },
  {
    "publicId": "44a5d1e93a7a9c664ef1e389",
    "title": "The Great Exhibition",
    "dateLabel": "1851 CE",
    "year": 1851,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/44a5d1e93a7a9c664ef1e389.webp"
  },
  {
    "publicId": "30c02b2d753df83058c465d5",
    "title": "Golden Spike Ceremony",
    "dateLabel": "1869 CE",
    "year": 1869,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/30c02b2d753df83058c465d5.webp"
  },
  {
    "publicId": "cc11ee62ae210450ac5e929b",
    "title": "Eiffel Tower Exposition",
    "dateLabel": "1889 CE",
    "year": 1889,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/cc11ee62ae210450ac5e929b.webp"
  },
  {
    "publicId": "903fe593ee3d2147844e85be",
    "title": "Wright Flyer First Flight",
    "dateLabel": "1903 CE",
    "year": 1903,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/903fe593ee3d2147844e85be.webp"
  },
  {
    "publicId": "97b92866cb2fab95b50a9b26",
    "title": "San Francisco Earthquake",
    "dateLabel": "1906 CE",
    "year": 1906,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/97b92866cb2fab95b50a9b26.webp"
  },
  {
    "publicId": "8d3cee5bcd1a4de1d3a0144c",
    "title": "Titanic Departs Southampton",
    "dateLabel": "1912 CE",
    "year": 1912,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/8d3cee5bcd1a4de1d3a0144c.webp"
  },
  {
    "publicId": "0c76cc4b26b1d248877553b0",
    "title": "Woman Suffrage Procession",
    "dateLabel": "1913 CE",
    "year": 1913,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/0c76cc4b26b1d248877553b0.webp"
  },
  {
    "publicId": "490edc55b322eee31c04faf0",
    "title": "D-Day at Omaha Beach",
    "dateLabel": "1944 CE",
    "year": 1944,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/490edc55b322eee31c04faf0.webp"
  },
  {
    "publicId": "e85b413afca8dd38ea64b104",
    "title": "VE Day in London",
    "dateLabel": "1945 CE",
    "year": 1945,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/e85b413afca8dd38ea64b104.webp"
  },
  {
    "publicId": "02e7152e93d0c53ce18c3006",
    "title": "Ghana Independence",
    "dateLabel": "1957 CE",
    "year": 1957,
    "era": "modern",
    "continent": "Africa",
    "url": "/panoramas/02e7152e93d0c53ce18c3006.webp"
  },
  {
    "publicId": "e34392e7d8948a74858aae79",
    "title": "Berlin Wall Construction",
    "dateLabel": "1961 CE",
    "year": 1961,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/e34392e7d8948a74858aae79.webp"
  },
  {
    "publicId": "a8da3609e7e0a62b94771da9",
    "title": "Apollo 11 Launch",
    "dateLabel": "1969 CE",
    "year": 1969,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/a8da3609e7e0a62b94771da9.webp"
  },
  {
    "publicId": "192322fd471863db89ad27d3",
    "title": "Lascaux Cave Painting",
    "dateLabel": "17000 BCE",
    "year": -17000,
    "era": "ancient",
    "continent": "Europe",
    "url": "/panoramas/192322fd471863db89ad27d3.webp"
  },
  {
    "publicId": "9b75c84112fc72cea5d7831e",
    "title": "Gobekli Tepe Enclosure",
    "dateLabel": "9500 BCE",
    "year": -9500,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/9b75c84112fc72cea5d7831e.webp"
  },
  {
    "publicId": "228fedbc216dfd8ad54faa4e",
    "title": "Tower of Jericho",
    "dateLabel": "8000 BCE",
    "year": -8000,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/228fedbc216dfd8ad54faa4e.webp"
  },
  {
    "publicId": "eb5919e56d0ad25f5500fe9c",
    "title": "Catalhoyuk Rooftop Settlement",
    "dateLabel": "7000 BCE",
    "year": -7000,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/eb5919e56d0ad25f5500fe9c.webp"
  },
  {
    "publicId": "9d9d286e4bc3f3b7ef11aab1",
    "title": "Ain Ghazal Statues",
    "dateLabel": "6500 BCE",
    "year": -6500,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/9d9d286e4bc3f3b7ef11aab1.webp"
  },
  {
    "publicId": "9556ebd8247a626a484a36bc",
    "title": "Mehrgarh Farming Village",
    "dateLabel": "6500 BCE",
    "year": -6500,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/9556ebd8247a626a484a36bc.webp"
  },
  {
    "publicId": "0d9de4cfe630039177945226",
    "title": "Nabta Playa Stone Circle",
    "dateLabel": "5000 BCE",
    "year": -5000,
    "era": "ancient",
    "continent": "Africa",
    "url": "/panoramas/0d9de4cfe630039177945226.webp"
  },
  {
    "publicId": "8d93ab70874c6d7e6c9b6957",
    "title": "Uruk City",
    "dateLabel": "3200 BCE",
    "year": -3200,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/8d93ab70874c6d7e6c9b6957.webp"
  },
  {
    "publicId": "54609b056dae6594c6edb626",
    "title": "Skara Brae Village",
    "dateLabel": "3100 BCE",
    "year": -3100,
    "era": "ancient",
    "continent": "Europe",
    "url": "/panoramas/54609b056dae6594c6edb626.webp"
  },
  {
    "publicId": "a2c4cd3fcacad322aa6a172b",
    "title": "Caral-Supe City",
    "dateLabel": "2600 BCE",
    "year": -2600,
    "era": "ancient",
    "continent": "South America",
    "url": "/panoramas/a2c4cd3fcacad322aa6a172b.webp"
  },
  {
    "publicId": "5e62b26b1214de14e37e2f37",
    "title": "Royal Cemetery of Ur",
    "dateLabel": "2550 BCE",
    "year": -2550,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/5e62b26b1214de14e37e2f37.webp"
  },
  {
    "publicId": "26b507c97c6f3256cbb6b29a",
    "title": "Code of Hammurabi Stele",
    "dateLabel": "1754 BCE",
    "year": -1754,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/26b507c97c6f3256cbb6b29a.webp"
  },
  {
    "publicId": "10f50fce8f20c7271905566f",
    "title": "Minoan Knossos Palace",
    "dateLabel": "1700 BCE",
    "year": -1700,
    "era": "ancient",
    "continent": "Europe",
    "url": "/panoramas/10f50fce8f20c7271905566f.webp"
  },
  {
    "publicId": "7e8a6133019acea4d82cb130",
    "title": "Hattusa Hittite Capital",
    "dateLabel": "1350 BCE",
    "year": -1350,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/7e8a6133019acea4d82cb130.webp"
  },
  {
    "publicId": "3affa4d1916aeae93d3459ff",
    "title": "Akhenaten's Amarna",
    "dateLabel": "1345 BCE",
    "year": -1345,
    "era": "ancient",
    "continent": "Africa",
    "url": "/panoramas/3affa4d1916aeae93d3459ff.webp"
  },
  {
    "publicId": "5a0bdaf41f52c8211b2bec29",
    "title": "Abu Simbel Carving",
    "dateLabel": "1264 BCE",
    "year": -1264,
    "era": "ancient",
    "continent": "Africa",
    "url": "/panoramas/5a0bdaf41f52c8211b2bec29.webp"
  },
  {
    "publicId": "a4b6dd10145cc2d651ed0340",
    "title": "Late Bronze Age Troy",
    "dateLabel": "1250 BCE",
    "year": -1250,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/a4b6dd10145cc2d651ed0340.webp"
  },
  {
    "publicId": "74422a0f43c60f5e8e1c40f4",
    "title": "First Olympic Games",
    "dateLabel": "776 BCE",
    "year": -776,
    "era": "ancient",
    "continent": "Europe",
    "url": "/panoramas/74422a0f43c60f5e8e1c40f4.webp"
  },
  {
    "publicId": "09e06f1449db639b00bf4d18",
    "title": "Persepolis Apadana",
    "dateLabel": "500 BCE",
    "year": -500,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/09e06f1449db639b00bf4d18.webp"
  },
  {
    "publicId": "51d9a54577fb3bf1aecd1e8a",
    "title": "Parthenon Construction",
    "dateLabel": "447 BCE",
    "year": -447,
    "era": "ancient",
    "continent": "Europe",
    "url": "/panoramas/51d9a54577fb3bf1aecd1e8a.webp"
  },
  {
    "publicId": "e2549ada32b6d57521b36122",
    "title": "Alexander Enters Babylon",
    "dateLabel": "331 BCE",
    "year": -331,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/e2549ada32b6d57521b36122.webp"
  },
  {
    "publicId": "c26a238c99d31f9e55ee2ad3",
    "title": "Qin Frontier Wall Works",
    "dateLabel": "214 BCE",
    "year": -214,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/c26a238c99d31f9e55ee2ad3.webp"
  },
  {
    "publicId": "694223f0580f137d019032df",
    "title": "Chang'an Silk Road Market",
    "dateLabel": "130 BCE",
    "year": -130,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/694223f0580f137d019032df.webp"
  },
  {
    "publicId": "a7e67f5d55f789529917605a",
    "title": "Boudica's Revolt at Londinium",
    "dateLabel": "60 CE",
    "year": 60,
    "era": "ancient",
    "continent": "Europe",
    "url": "/panoramas/a7e67f5d55f789529917605a.webp"
  },
  {
    "publicId": "f803034245d371265911608a",
    "title": "Pompeii Street Before Vesuvius",
    "dateLabel": "79 CE",
    "year": 79,
    "era": "ancient",
    "continent": "Europe",
    "url": "/panoramas/f803034245d371265911608a.webp"
  },
  {
    "publicId": "9274cba6d135594de3377ede",
    "title": "Lindisfarne Raid",
    "dateLabel": "793 CE",
    "year": 793,
    "era": "medieval",
    "continent": "Europe",
    "url": "/panoramas/9274cba6d135594de3377ede.webp"
  },
  {
    "publicId": "25442a60dc67469b63cd264e",
    "title": "Charlemagne Crowned Emperor",
    "dateLabel": "800 CE",
    "year": 800,
    "era": "medieval",
    "continent": "Europe",
    "url": "/panoramas/25442a60dc67469b63cd264e.webp"
  },
  {
    "publicId": "0a2675e2d85be632db5bde41",
    "title": "Settlement of Reykjavik",
    "dateLabel": "874 CE",
    "year": 874,
    "era": "medieval",
    "continent": "Europe",
    "url": "/panoramas/0a2675e2d85be632db5bde41.webp"
  },
  {
    "publicId": "dbefea9f5be4547d44dfdbe7",
    "title": "Cluny Abbey Founded",
    "dateLabel": "910 CE",
    "year": 910,
    "era": "medieval",
    "continent": "Europe",
    "url": "/panoramas/dbefea9f5be4547d44dfdbe7.webp"
  },
  {
    "publicId": "3798ae4e1c0bffaf846d84bc",
    "title": "Heian-kyo Court",
    "dateLabel": "1000 CE",
    "year": 1000,
    "era": "medieval",
    "continent": "Asia",
    "url": "/panoramas/3798ae4e1c0bffaf846d84bc.webp"
  },
  {
    "publicId": "908df0b6a89d4482999b0fe5",
    "title": "Battle of Hastings",
    "dateLabel": "1066 CE",
    "year": 1066,
    "era": "medieval",
    "continent": "Europe",
    "url": "/panoramas/908df0b6a89d4482999b0fe5.webp"
  },
  {
    "publicId": "29e00b71d63b4cd2045fae74",
    "title": "First Crusade at Jerusalem",
    "dateLabel": "1099 CE",
    "year": 1099,
    "era": "medieval",
    "continent": "Asia",
    "url": "/panoramas/29e00b71d63b4cd2045fae74.webp"
  },
  {
    "publicId": "26b9b31517d90ccf3ba3902f",
    "title": "Chartres Cathedral Rebuild",
    "dateLabel": "1194 CE",
    "year": 1194,
    "era": "medieval",
    "continent": "Europe",
    "url": "/panoramas/26b9b31517d90ccf3ba3902f.webp"
  },
  {
    "publicId": "b084ba26f08205a58129ca53",
    "title": "Karakorum Mongol Capital",
    "dateLabel": "1235 CE",
    "year": 1235,
    "era": "medieval",
    "continent": "Asia",
    "url": "/panoramas/b084ba26f08205a58129ca53.webp"
  },
  {
    "publicId": "5549ef8593354ae6fb1c63a3",
    "title": "Alhambra Nasrid Palace",
    "dateLabel": "1354 CE",
    "year": 1354,
    "era": "medieval",
    "continent": "Europe",
    "url": "/panoramas/5549ef8593354ae6fb1c63a3.webp"
  },
  {
    "publicId": "6e1801c357fd9da546b4f4ab",
    "title": "Zheng He's Treasure Fleet",
    "dateLabel": "1405 CE",
    "year": 1405,
    "era": "medieval",
    "continent": "Asia",
    "url": "/panoramas/6e1801c357fd9da546b4f4ab.webp"
  },
  {
    "publicId": "4ec462dd234f4f692515deff",
    "title": "Vasco da Gama Reaches Calicut",
    "dateLabel": "1498 CE",
    "year": 1498,
    "era": "medieval",
    "continent": "Asia",
    "url": "/panoramas/4ec462dd234f4f692515deff.webp"
  },
  {
    "publicId": "2d70b4db4adbeb74511fce4a",
    "title": "Wittenberg Reformation",
    "dateLabel": "1517 CE",
    "year": 1517,
    "era": "early-modern",
    "continent": "Europe",
    "url": "/panoramas/2d70b4db4adbeb74511fce4a.webp"
  },
  {
    "publicId": "25dfcde4584aae1ee7df9e76",
    "title": "Potosi Silver Mountain",
    "dateLabel": "1545 CE",
    "year": 1545,
    "era": "early-modern",
    "continent": "South America",
    "url": "/panoramas/25dfcde4584aae1ee7df9e76.webp"
  },
  {
    "publicId": "92ea4d2f36636166867ac528",
    "title": "Spanish Armada at Gravelines",
    "dateLabel": "1588 CE",
    "year": 1588,
    "era": "early-modern",
    "continent": "Europe",
    "url": "/panoramas/92ea4d2f36636166867ac528.webp"
  },
  {
    "publicId": "f2824b4305e03190dfa144bc",
    "title": "Tulip Auction in Amsterdam",
    "dateLabel": "1637 CE",
    "year": 1637,
    "era": "early-modern",
    "continent": "Europe",
    "url": "/panoramas/f2824b4305e03190dfa144bc.webp"
  },
  {
    "publicId": "465a46bdb603841dff31854f",
    "title": "Taj Mahal Completion",
    "dateLabel": "1648 CE",
    "year": 1648,
    "era": "early-modern",
    "continent": "Asia",
    "url": "/panoramas/465a46bdb603841dff31854f.webp"
  },
  {
    "publicId": "c73eeed54a493a7f5dd8f463",
    "title": "St. Petersburg Founded",
    "dateLabel": "1703 CE",
    "year": 1703,
    "era": "early-modern",
    "continent": "Europe",
    "url": "/panoramas/c73eeed54a493a7f5dd8f463.webp"
  },
  {
    "publicId": "524d64bf38c441baeee989d9",
    "title": "Declaration of Independence",
    "dateLabel": "1776 CE",
    "year": 1776,
    "era": "early-modern",
    "continent": "North America",
    "url": "/panoramas/524d64bf38c441baeee989d9.webp"
  },
  {
    "publicId": "f90032f58fd99eeeb7d6bd5a",
    "title": "Bois Caiman Ceremony",
    "dateLabel": "1791 CE",
    "year": 1791,
    "era": "early-modern",
    "continent": "North America",
    "url": "/panoramas/f90032f58fd99eeeb7d6bd5a.webp"
  },
  {
    "publicId": "8fa7969e524cde34e9d417c3",
    "title": "Meiji Restoration",
    "dateLabel": "1868 CE",
    "year": 1868,
    "era": "modern",
    "continent": "Asia",
    "url": "/panoramas/8fa7969e524cde34e9d417c3.webp"
  },
  {
    "publicId": "5c936eaeefb0d1c0dc082814",
    "title": "Nelson Mandela Inauguration",
    "dateLabel": "1994 CE",
    "year": 1994,
    "era": "modern",
    "continent": "Africa",
    "url": "/panoramas/5c936eaeefb0d1c0dc082814.webp"
  },
  {
    "publicId": "2aeae6192584130bb67012f2",
    "title": "Beijing Olympics Opening",
    "dateLabel": "2008 CE",
    "year": 2008,
    "era": "modern",
    "continent": "Asia",
    "url": "/panoramas/2aeae6192584130bb67012f2.webp"
  },
  {
    "publicId": "0b9b07626c52711b481e91e3",
    "title": "Paris Olympics Opening",
    "dateLabel": "2024 CE",
    "year": 2024,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/0b9b07626c52711b481e91e3.webp"
  },
  {
    "publicId": "59c9998efb8c9c105eafde4c",
    "title": "Milano Cortina Opening Ceremony",
    "dateLabel": "2026 CE",
    "year": 2026,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/59c9998efb8c9c105eafde4c.webp"
  },
  {
    "publicId": "45f5b8986b99267984718e75",
    "title": "Chauvet Cave Painting",
    "dateLabel": "32000 BCE",
    "year": -32000,
    "era": "ancient",
    "continent": "Europe",
    "url": "/panoramas/45f5b8986b99267984718e75.webp"
  },
  {
    "publicId": "8589c5199ffe2ecc721f43bc",
    "title": "Narmer Palette at Hierakonpolis",
    "dateLabel": "3100 BCE",
    "year": -3100,
    "era": "ancient",
    "continent": "Africa",
    "url": "/panoramas/8589c5199ffe2ecc721f43bc.webp"
  },
  {
    "publicId": "d04088457e30548bcede81f2",
    "title": "Battle of Megiddo",
    "dateLabel": "1457 BCE",
    "year": -1457,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/d04088457e30548bcede81f2.webp"
  },
  {
    "publicId": "5bfd2cd192961bc779e32af3",
    "title": "Battle of Kadesh",
    "dateLabel": "1274 BCE",
    "year": -1274,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/5bfd2cd192961bc779e32af3.webp"
  },
  {
    "publicId": "adbbf1fe2ec36a279b210fdb",
    "title": "Mycenae Lion Gate",
    "dateLabel": "1250 BCE",
    "year": -1250,
    "era": "ancient",
    "continent": "Europe",
    "url": "/panoramas/adbbf1fe2ec36a279b210fdb.webp"
  },
  {
    "publicId": "0329059347232aa73f6bc7c2",
    "title": "Carthage Founded",
    "dateLabel": "814 BCE",
    "year": -814,
    "era": "ancient",
    "continent": "Africa",
    "url": "/panoramas/0329059347232aa73f6bc7c2.webp"
  },
  {
    "publicId": "2e93265da23ecdba1e811c08",
    "title": "Library of Ashurbanipal",
    "dateLabel": "650 BCE",
    "year": -650,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/2e93265da23ecdba1e811c08.webp"
  },
  {
    "publicId": "739900ded5e930a597689c23",
    "title": "Battle of Marathon",
    "dateLabel": "490 BCE",
    "year": -490,
    "era": "ancient",
    "continent": "Europe",
    "url": "/panoramas/739900ded5e930a597689c23.webp"
  },
  {
    "publicId": "687a8621ee96b304d58422b1",
    "title": "Battle of Thermopylae",
    "dateLabel": "480 BCE",
    "year": -480,
    "era": "ancient",
    "continent": "Europe",
    "url": "/panoramas/687a8621ee96b304d58422b1.webp"
  },
  {
    "publicId": "d2cc9771bb72633945544de4",
    "title": "Kalinga War at Dhauli",
    "dateLabel": "261 BCE",
    "year": -261,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/d2cc9771bb72633945544de4.webp"
  },
  {
    "publicId": "9fd16c613752e3442f107df8",
    "title": "Battle of Cannae",
    "dateLabel": "216 BCE",
    "year": -216,
    "era": "ancient",
    "continent": "Europe",
    "url": "/panoramas/9fd16c613752e3442f107df8.webp"
  },
  {
    "publicId": "70e604f346f5f55b55522dac",
    "title": "Battle of Actium",
    "dateLabel": "31 BCE",
    "year": -31,
    "era": "ancient",
    "continent": "Europe",
    "url": "/panoramas/70e604f346f5f55b55522dac.webp"
  },
  {
    "publicId": "a7505e46897bd08413a532c9",
    "title": "Siege of Masada",
    "dateLabel": "73 CE",
    "year": 73,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/a7505e46897bd08413a532c9.webp"
  },
  {
    "publicId": "9550a75b971335b7c3f35d96",
    "title": "First Council of Nicaea",
    "dateLabel": "325 CE",
    "year": 325,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/9550a75b971335b7c3f35d96.webp"
  },
  {
    "publicId": "989954d641cdd4cc201082ac",
    "title": "San Vitale Consecrated",
    "dateLabel": "547 CE",
    "year": 547,
    "era": "medieval",
    "continent": "Europe",
    "url": "/panoramas/989954d641cdd4cc201082ac.webp"
  },
  {
    "publicId": "5a6a6d2210a0c5d0cd2788de",
    "title": "Synod of Whitby",
    "dateLabel": "664 CE",
    "year": 664,
    "era": "medieval",
    "continent": "Europe",
    "url": "/panoramas/5a6a6d2210a0c5d0cd2788de.webp"
  },
  {
    "publicId": "581d42d5dc96e0a8f6ef0324",
    "title": "Great Mosque of Cordoba Begins",
    "dateLabel": "785 CE",
    "year": 785,
    "era": "medieval",
    "continent": "Europe",
    "url": "/panoramas/581d42d5dc96e0a8f6ef0324.webp"
  },
  {
    "publicId": "1ae806f8c39ee3d33fa239a8",
    "title": "Borobudur Completed",
    "dateLabel": "825 CE",
    "year": 825,
    "era": "medieval",
    "continent": "Asia",
    "url": "/panoramas/1ae806f8c39ee3d33fa239a8.webp"
  },
  {
    "publicId": "94c3a0d389a4d10dbf8e40c2",
    "title": "Battle of Manzikert",
    "dateLabel": "1071 CE",
    "year": 1071,
    "era": "medieval",
    "continent": "Asia",
    "url": "/panoramas/94c3a0d389a4d10dbf8e40c2.webp"
  },
  {
    "publicId": "24fc00137e389ae162bc136b",
    "title": "Walk to Canossa",
    "dateLabel": "1077 CE",
    "year": 1077,
    "era": "medieval",
    "continent": "Europe",
    "url": "/panoramas/24fc00137e389ae162bc136b.webp"
  },
  {
    "publicId": "4abe21f70773c5a3b2f09158",
    "title": "Magna Carta Sealed",
    "dateLabel": "1215 CE",
    "year": 1215,
    "era": "medieval",
    "continent": "Europe",
    "url": "/panoramas/4abe21f70773c5a3b2f09158.webp"
  },
  {
    "publicId": "a9b5c985bac503fa1ac6d746",
    "title": "Battle of Bannockburn",
    "dateLabel": "1314 CE",
    "year": 1314,
    "era": "medieval",
    "continent": "Europe",
    "url": "/panoramas/a9b5c985bac503fa1ac6d746.webp"
  },
  {
    "publicId": "77dabc4fc4654398e90e691b",
    "title": "Mansa Musa in Cairo",
    "dateLabel": "1324 CE",
    "year": 1324,
    "era": "medieval",
    "continent": "Africa",
    "url": "/panoramas/77dabc4fc4654398e90e691b.webp"
  },
  {
    "publicId": "983fd62ffaf5edaefaf7e4eb",
    "title": "Florence Cathedral Dome Completed",
    "dateLabel": "1436 CE",
    "year": 1436,
    "era": "medieval",
    "continent": "Europe",
    "url": "/panoramas/983fd62ffaf5edaefaf7e4eb.webp"
  },
  {
    "publicId": "55d8a071dd6767ec91c6cbfd",
    "title": "Siege of Orleans Lifted",
    "dateLabel": "1429 CE",
    "year": 1429,
    "era": "medieval",
    "continent": "Europe",
    "url": "/panoramas/55d8a071dd6767ec91c6cbfd.webp"
  },
  {
    "publicId": "0e04fb2a12f3900bc967db0b",
    "title": "Battle of Bosworth Field",
    "dateLabel": "1485 CE",
    "year": 1485,
    "era": "medieval",
    "continent": "Europe",
    "url": "/panoramas/0e04fb2a12f3900bc967db0b.webp"
  },
  {
    "publicId": "636f1f3d8cec8a8fc7a8b772",
    "title": "Diet of Worms",
    "dateLabel": "1521 CE",
    "year": 1521,
    "era": "early-modern",
    "continent": "Europe",
    "url": "/panoramas/636f1f3d8cec8a8fc7a8b772.webp"
  },
  {
    "publicId": "c90943e445e0d2e266bbaa71",
    "title": "Battle of Cajamarca",
    "dateLabel": "1532 CE",
    "year": 1532,
    "era": "early-modern",
    "continent": "South America",
    "url": "/panoramas/c90943e445e0d2e266bbaa71.webp"
  },
  {
    "publicId": "8c3ef937249eefc19f7c6986",
    "title": "Council of Trent Opens",
    "dateLabel": "1545 CE",
    "year": 1545,
    "era": "early-modern",
    "continent": "Europe",
    "url": "/panoramas/8c3ef937249eefc19f7c6986.webp"
  },
  {
    "publicId": "2c4f7f8093bd6638af9c5ffa",
    "title": "Battle of Lepanto",
    "dateLabel": "1571 CE",
    "year": 1571,
    "era": "early-modern",
    "continent": "Europe",
    "url": "/panoramas/2c4f7f8093bd6638af9c5ffa.webp"
  },
  {
    "publicId": "c90b5109774e74f965c9719d",
    "title": "Battle of Sekigahara",
    "dateLabel": "1600 CE",
    "year": 1600,
    "era": "early-modern",
    "continent": "Asia",
    "url": "/panoramas/c90b5109774e74f965c9719d.webp"
  },
  {
    "publicId": "29d0b101dbf2fcfa520d3bde",
    "title": "Mayflower Compact Signed",
    "dateLabel": "1620 CE",
    "year": 1620,
    "era": "early-modern",
    "continent": "North America",
    "url": "/panoramas/29d0b101dbf2fcfa520d3bde.webp"
  },
  {
    "publicId": "034fd8285bf1758594f21c1e",
    "title": "Battle of Naseby",
    "dateLabel": "1645 CE",
    "year": 1645,
    "era": "early-modern",
    "continent": "Europe",
    "url": "/panoramas/034fd8285bf1758594f21c1e.webp"
  },
  {
    "publicId": "13551c207bc008b63612742f",
    "title": "Battle of Vienna",
    "dateLabel": "1683 CE",
    "year": 1683,
    "era": "early-modern",
    "continent": "Europe",
    "url": "/panoramas/13551c207bc008b63612742f.webp"
  },
  {
    "publicId": "95a39b5ff0999838eb37817d",
    "title": "Battle of Quebec",
    "dateLabel": "1759 CE",
    "year": 1759,
    "era": "early-modern",
    "continent": "North America",
    "url": "/panoramas/95a39b5ff0999838eb37817d.webp"
  },
  {
    "publicId": "c59bd5a74211c5e49a4bfbf2",
    "title": "First Fleet at Sydney Cove",
    "dateLabel": "1788 CE",
    "year": 1788,
    "era": "early-modern",
    "continent": "Oceania",
    "url": "/panoramas/c59bd5a74211c5e49a4bfbf2.webp"
  },
  {
    "publicId": "d689ca4a98fbcd1a59c210ef",
    "title": "Rosetta Stone Discovered",
    "dateLabel": "1799 CE",
    "year": 1799,
    "era": "early-modern",
    "continent": "Africa",
    "url": "/panoramas/d689ca4a98fbcd1a59c210ef.webp"
  },
  {
    "publicId": "341c09432624e201aa24a0f2",
    "title": "Battle of Waterloo",
    "dateLabel": "1815 CE",
    "year": 1815,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/341c09432624e201aa24a0f2.webp"
  },
  {
    "publicId": "f028877465f0c8752bf0e403",
    "title": "Seneca Falls Convention",
    "dateLabel": "1848 CE",
    "year": 1848,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/f028877465f0c8752bf0e403.webp"
  },
  {
    "publicId": "a7685774e670169a1492350b",
    "title": "Drake Well Strikes Oil",
    "dateLabel": "1859 CE",
    "year": 1859,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/a7685774e670169a1492350b.webp"
  },
  {
    "publicId": "02659dacad3e7d0c3b043481",
    "title": "Gettysburg Address",
    "dateLabel": "1863 CE",
    "year": 1863,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/02659dacad3e7d0c3b043481.webp"
  },
  {
    "publicId": "4d3905281327d38d448d729a",
    "title": "Suez Canal Opens",
    "dateLabel": "1869 CE",
    "year": 1869,
    "era": "modern",
    "continent": "Africa",
    "url": "/panoramas/4d3905281327d38d448d729a.webp"
  },
  {
    "publicId": "feef70c724a2e3db9266cf0c",
    "title": "Battle of the Little Bighorn",
    "dateLabel": "1876 CE",
    "year": 1876,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/feef70c724a2e3db9266cf0c.webp"
  },
  {
    "publicId": "4e86092082fdbf24b49b57eb",
    "title": "Haymarket Affair",
    "dateLabel": "1886 CE",
    "year": 1886,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/4e86092082fdbf24b49b57eb.webp"
  },
  {
    "publicId": "926b52d104dc99699a80640e",
    "title": "Salt March Reaches Dandi",
    "dateLabel": "1930 CE",
    "year": 1930,
    "era": "modern",
    "continent": "Asia",
    "url": "/panoramas/926b52d104dc99699a80640e.webp"
  },
  {
    "publicId": "0e3469e61b09e5a26475fed9",
    "title": "Attack on Pearl Harbor",
    "dateLabel": "1941 CE",
    "year": 1941,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/0e3469e61b09e5a26475fed9.webp"
  },
  {
    "publicId": "c2573c901af373cfcd742da3",
    "title": "Hiroshima Bombing",
    "dateLabel": "1945 CE",
    "year": 1945,
    "era": "modern",
    "continent": "Asia",
    "url": "/panoramas/c2573c901af373cfcd742da3.webp"
  },
  {
    "publicId": "c4e02d7a3d8381d9063ad3a0",
    "title": "Sputnik Launch",
    "dateLabel": "1957 CE",
    "year": 1957,
    "era": "modern",
    "continent": "Asia",
    "url": "/panoramas/c4e02d7a3d8381d9063ad3a0.webp"
  },
  {
    "publicId": "a004494d43c9dc38a3ea41df",
    "title": "World Wide Web Proposal",
    "dateLabel": "1989 CE",
    "year": 1989,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/a004494d43c9dc38a3ea41df.webp"
  },
  {
    "publicId": "d2204da39a58020a66429df1",
    "title": "Chernobyl Disaster",
    "dateLabel": "1986 CE",
    "year": 1986,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/d2204da39a58020a66429df1.webp"
  },
  {
    "publicId": "7997dc3513857068a9ababc3",
    "title": "Mohenjo-daro Great Bath",
    "dateLabel": "2500 BCE",
    "year": -2500,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/7997dc3513857068a9ababc3.webp"
  },
  {
    "publicId": "ac8b31e58df733519d53b191",
    "title": "Opet Festival at Karnak",
    "dateLabel": "1250 BCE",
    "year": -1250,
    "era": "ancient",
    "continent": "Africa",
    "url": "/panoramas/ac8b31e58df733519d53b191.webp"
  },
  {
    "publicId": "3c1d458b2319d024f573d9db",
    "title": "Oracle at Delphi",
    "dateLabel": "550 BCE",
    "year": -550,
    "era": "ancient",
    "continent": "Europe",
    "url": "/panoramas/3c1d458b2319d024f573d9db.webp"
  },
  {
    "publicId": "0987326e151c248652b3e245",
    "title": "Petra Treasury",
    "dateLabel": "100 BCE",
    "year": -100,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/0987326e151c248652b3e245.webp"
  },
  {
    "publicId": "bc21b3f925205402f00395c4",
    "title": "Temple of Bel at Palmyra",
    "dateLabel": "32 CE",
    "year": 32,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/bc21b3f925205402f00395c4.webp"
  },
  {
    "publicId": "06c9fb97a2104ab3bb1f9675",
    "title": "Pont du Gard Aqueduct",
    "dateLabel": "50 CE",
    "year": 50,
    "era": "ancient",
    "continent": "Europe",
    "url": "/panoramas/06c9fb97a2104ab3bb1f9675.webp"
  },
  {
    "publicId": "c8e0404d7c26196f93da4b65",
    "title": "Nazca Lines",
    "dateLabel": "500 CE",
    "year": 500,
    "era": "medieval",
    "continent": "South America",
    "url": "/panoramas/c8e0404d7c26196f93da4b65.webp"
  },
  {
    "publicId": "59bef239fb0965bcced6193b",
    "title": "Tikal Great Plaza",
    "dateLabel": "750 CE",
    "year": 750,
    "era": "medieval",
    "continent": "North America",
    "url": "/panoramas/59bef239fb0965bcced6193b.webp"
  },
  {
    "publicId": "24206ec0c6b163c4c5e479ac",
    "title": "Temple of Kukulcan",
    "dateLabel": "1000 CE",
    "year": 1000,
    "era": "medieval",
    "continent": "North America",
    "url": "/panoramas/24206ec0c6b163c4c5e479ac.webp"
  },
  {
    "publicId": "758046434acd2b31f6d45bcd",
    "title": "Cahokia Monks Mound",
    "dateLabel": "1100 CE",
    "year": 1100,
    "era": "medieval",
    "continent": "North America",
    "url": "/panoramas/758046434acd2b31f6d45bcd.webp"
  },
  {
    "publicId": "9b5a590d9a55c2a5db9c5f95",
    "title": "Mesa Verde Cliff Palace",
    "dateLabel": "1200 CE",
    "year": 1200,
    "era": "medieval",
    "continent": "North America",
    "url": "/panoramas/9b5a590d9a55c2a5db9c5f95.webp"
  },
  {
    "publicId": "ec11dc25c6fe16ca5a42485e",
    "title": "Leaning Tower of Pisa Completed",
    "dateLabel": "1372 CE",
    "year": 1372,
    "era": "medieval",
    "continent": "Europe",
    "url": "/panoramas/ec11dc25c6fe16ca5a42485e.webp"
  },
  {
    "publicId": "1f83651d552c79e878070bce",
    "title": "Moai at Rano Raraku",
    "dateLabel": "1400 CE",
    "year": 1400,
    "era": "medieval",
    "continent": "South America",
    "url": "/panoramas/1f83651d552c79e878070bce.webp"
  },
  {
    "publicId": "8b6a5a3689e66b2a1310726f",
    "title": "Forbidden City Opens",
    "dateLabel": "1420 CE",
    "year": 1420,
    "era": "medieval",
    "continent": "Asia",
    "url": "/panoramas/8b6a5a3689e66b2a1310726f.webp"
  },
  {
    "publicId": "19d3bd02d31e5ec0af18023d",
    "title": "Ming Great Wall at Badaling",
    "dateLabel": "1505 CE",
    "year": 1505,
    "era": "early-modern",
    "continent": "Asia",
    "url": "/panoramas/19d3bd02d31e5ec0af18023d.webp"
  },
  {
    "publicId": "b9d8d706182dbecf6e022ddb",
    "title": "St. Basil's Cathedral Consecrated",
    "dateLabel": "1561 CE",
    "year": 1561,
    "era": "early-modern",
    "continent": "Europe",
    "url": "/panoramas/b9d8d706182dbecf6e022ddb.webp"
  },
  {
    "publicId": "28259d76a6ebfc894e669d0f",
    "title": "Himeji Castle Completed",
    "dateLabel": "1609 CE",
    "year": 1609,
    "era": "early-modern",
    "continent": "Asia",
    "url": "/panoramas/28259d76a6ebfc894e669d0f.webp"
  },
  {
    "publicId": "33aeef972261558372da602d",
    "title": "Potala Palace Rises",
    "dateLabel": "1649 CE",
    "year": 1649,
    "era": "early-modern",
    "continent": "Asia",
    "url": "/panoramas/33aeef972261558372da602d.webp"
  },
  {
    "publicId": "79b329a70928ba5d86ea244f",
    "title": "Surrender at Yorktown",
    "dateLabel": "1781 CE",
    "year": 1781,
    "era": "early-modern",
    "continent": "North America",
    "url": "/panoramas/79b329a70928ba5d86ea244f.webp"
  },
  {
    "publicId": "526ffa6c4ceec8d7246f2e90",
    "title": "Battle of the Alamo",
    "dateLabel": "1836 CE",
    "year": 1836,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/526ffa6c4ceec8d7246f2e90.webp"
  },
  {
    "publicId": "7df3f5a36cf26da9b3d6638f",
    "title": "Fort Sumter Bombarded",
    "dateLabel": "1861 CE",
    "year": 1861,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/7df3f5a36cf26da9b3d6638f.webp"
  },
  {
    "publicId": "b573637fccb295bcfa3b8153",
    "title": "Appomattox Surrender",
    "dateLabel": "1865 CE",
    "year": 1865,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/b573637fccb295bcfa3b8153.webp"
  },
  {
    "publicId": "09590677286c1c48c617cfd3",
    "title": "First Modern Olympics",
    "dateLabel": "1896 CE",
    "year": 1896,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/09590677286c1c48c617cfd3.webp"
  },
  {
    "publicId": "fff0f6a68f662a5a72589da7",
    "title": "Sagrada Familia Begins",
    "dateLabel": "1882 CE",
    "year": 1882,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/fff0f6a68f662a5a72589da7.webp"
  },
  {
    "publicId": "eebf14085eeef3c9be3f2170",
    "title": "Statue of Liberty Dedicated",
    "dateLabel": "1886 CE",
    "year": 1886,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/eebf14085eeef3c9be3f2170.webp"
  },
  {
    "publicId": "276d1d7ec245700c35334b2b",
    "title": "Panama Canal Opens",
    "dateLabel": "1914 CE",
    "year": 1914,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/276d1d7ec245700c35334b2b.webp"
  },
  {
    "publicId": "18d343b864a15dd7eda4f631",
    "title": "Tutankhamun's Tomb Discovered",
    "dateLabel": "1922 CE",
    "year": 1922,
    "era": "modern",
    "continent": "Africa",
    "url": "/panoramas/18d343b864a15dd7eda4f631.webp"
  },
  {
    "publicId": "d39a64b019a411bf0df615fe",
    "title": "Christ the Redeemer Inaugurated",
    "dateLabel": "1931 CE",
    "year": 1931,
    "era": "modern",
    "continent": "South America",
    "url": "/panoramas/d39a64b019a411bf0df615fe.webp"
  },
  {
    "publicId": "604c38fa34f92d97c9b9efc0",
    "title": "Hoover Dam Dedicated",
    "dateLabel": "1935 CE",
    "year": 1935,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/604c38fa34f92d97c9b9efc0.webp"
  },
  {
    "publicId": "d8ec09c55563dcc5b0f1f2e8",
    "title": "Hindenburg Disaster",
    "dateLabel": "1937 CE",
    "year": 1937,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/d8ec09c55563dcc5b0f1f2e8.webp"
  },
  {
    "publicId": "995f862a1e831440a9cb32c6",
    "title": "Golden Gate Bridge Opens",
    "dateLabel": "1937 CE",
    "year": 1937,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/995f862a1e831440a9cb32c6.webp"
  },
  {
    "publicId": "8239278c7723750543fd5081",
    "title": "Dunkirk Evacuation",
    "dateLabel": "1940 CE",
    "year": 1940,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/8239278c7723750543fd5081.webp"
  },
  {
    "publicId": "5cb7fab11987c302cdc92a75",
    "title": "Mount Rushmore Completed",
    "dateLabel": "1941 CE",
    "year": 1941,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/5cb7fab11987c302cdc92a75.webp"
  },
  {
    "publicId": "aaf518cff0000ef1cb9b6792",
    "title": "Auschwitz Liberated",
    "dateLabel": "1945 CE",
    "year": 1945,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/aaf518cff0000ef1cb9b6792.webp"
  },
  {
    "publicId": "c86a5cc917e6be3680b9aaaf",
    "title": "Flag Raising on Iwo Jima",
    "dateLabel": "1945 CE",
    "year": 1945,
    "era": "modern",
    "continent": "Asia",
    "url": "/panoramas/c86a5cc917e6be3680b9aaaf.webp"
  },
  {
    "publicId": "734f9e1927fac89d77f613b3",
    "title": "Yalta Conference",
    "dateLabel": "1945 CE",
    "year": 1945,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/734f9e1927fac89d77f613b3.webp"
  },
  {
    "publicId": "4c0892e417449a37c7867a6b",
    "title": "Maracana World Cup Final",
    "dateLabel": "1950 CE",
    "year": 1950,
    "era": "modern",
    "continent": "South America",
    "url": "/panoramas/4c0892e417449a37c7867a6b.webp"
  },
  {
    "publicId": "7d83f7be76f6eb0153184d38",
    "title": "First Everest Summit",
    "dateLabel": "1953 CE",
    "year": 1953,
    "era": "modern",
    "continent": "Asia",
    "url": "/panoramas/7d83f7be76f6eb0153184d38.webp"
  },
  {
    "publicId": "ba6b39d93377370b6f783f4b",
    "title": "Rosa Parks Arrest",
    "dateLabel": "1955 CE",
    "year": 1955,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/ba6b39d93377370b6f783f4b.webp"
  },
  {
    "publicId": "ac82d5545d9731f042c2c6cb",
    "title": "I Have a Dream Speech",
    "dateLabel": "1963 CE",
    "year": 1963,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/ac82d5545d9731f042c2c6cb.webp"
  },
  {
    "publicId": "b7606caef04ec166dca93d8a",
    "title": "Selma Bridge Crossing",
    "dateLabel": "1965 CE",
    "year": 1965,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/b7606caef04ec166dca93d8a.webp"
  },
  {
    "publicId": "17bedbce8aa25c40bfc242e6",
    "title": "Woodstock Festival",
    "dateLabel": "1969 CE",
    "year": 1969,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/17bedbce8aa25c40bfc242e6.webp"
  },
  {
    "publicId": "bef7be121e609d1bb5d81b35",
    "title": "Fall of Saigon",
    "dateLabel": "1975 CE",
    "year": 1975,
    "era": "modern",
    "continent": "Asia",
    "url": "/panoramas/bef7be121e609d1bb5d81b35.webp"
  },
  {
    "publicId": "a9ef1783e72010b9a80626fe",
    "title": "Tiananmen Square Protests",
    "dateLabel": "1989 CE",
    "year": 1989,
    "era": "modern",
    "continent": "Asia",
    "url": "/panoramas/a9ef1783e72010b9a80626fe.webp"
  },
  {
    "publicId": "115929f321539376b77a83f4",
    "title": "Nelson Mandela Released",
    "dateLabel": "1990 CE",
    "year": 1990,
    "era": "modern",
    "continent": "Africa",
    "url": "/panoramas/115929f321539376b77a83f4.webp"
  },
  {
    "publicId": "375a9d9db83b027aadd5bf34",
    "title": "Channel Tunnel Opens",
    "dateLabel": "1994 CE",
    "year": 1994,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/375a9d9db83b027aadd5bf34.webp"
  },
  {
    "publicId": "af93ac2c1e2d6d7613fae4f9",
    "title": "First iPhone Revealed",
    "dateLabel": "2007 CE",
    "year": 2007,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/af93ac2c1e2d6d7613fae4f9.webp"
  },
  {
    "publicId": "f7bc1d2ae646a6c1abfe6b39",
    "title": "Burj Khalifa Opens",
    "dateLabel": "2010 CE",
    "year": 2010,
    "era": "modern",
    "continent": "Asia",
    "url": "/panoramas/f7bc1d2ae646a6c1abfe6b39.webp"
  },
  {
    "publicId": "425aa39cca0910ff0489a705",
    "title": "Trinity Test",
    "dateLabel": "1945 CE",
    "year": 1945,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/425aa39cca0910ff0489a705.webp"
  },
  {
    "publicId": "adaca90b80fcc4d76e79d78e",
    "title": "Bletchley Park Codebreakers",
    "dateLabel": "1941 CE",
    "year": 1941,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/adaca90b80fcc4d76e79d78e.webp"
  },
  {
    "publicId": "99b24f6e8561556ef5572ba1",
    "title": "Sanchi Great Stupa Expansion",
    "dateLabel": "250 BCE",
    "year": -250,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/99b24f6e8561556ef5572ba1.webp"
  },
  {
    "publicId": "a52c043caefd5e3f7ae57106",
    "title": "Trajan's Column Dedicated",
    "dateLabel": "113 CE",
    "year": 113,
    "era": "ancient",
    "continent": "Europe",
    "url": "/panoramas/a52c043caefd5e3f7ae57106.webp"
  },
  {
    "publicId": "6455bbcfcb4f25106c55b611",
    "title": "Bamiyan Buddhas at Their Height",
    "dateLabel": "600 CE",
    "year": 600,
    "era": "medieval",
    "continent": "Asia",
    "url": "/panoramas/6455bbcfcb4f25106c55b611.webp"
  },
  {
    "publicId": "2336b69bb6697123a10df5a3",
    "title": "Great Buddha of Nara Dedicated",
    "dateLabel": "752 CE",
    "year": 752,
    "era": "medieval",
    "continent": "Asia",
    "url": "/panoramas/2336b69bb6697123a10df5a3.webp"
  },
  {
    "publicId": "ae464fee566772d338835dd3",
    "title": "Leshan Giant Buddha Carving",
    "dateLabel": "803 CE",
    "year": 803,
    "era": "medieval",
    "continent": "Asia",
    "url": "/panoramas/ae464fee566772d338835dd3.webp"
  },
  {
    "publicId": "42431f130a8c0b51bc978998",
    "title": "L'Anse aux Meadows Settlement",
    "dateLabel": "1000 CE",
    "year": 1000,
    "era": "medieval",
    "continent": "North America",
    "url": "/panoramas/42431f130a8c0b51bc978998.webp"
  },
  {
    "publicId": "1c127f74cd8b4069249453cb",
    "title": "Ananda Temple Dedicated",
    "dateLabel": "1105 CE",
    "year": 1105,
    "era": "medieval",
    "continent": "Asia",
    "url": "/panoramas/1c127f74cd8b4069249453cb.webp"
  },
  {
    "publicId": "1c78f37419f91fe61643ad9b",
    "title": "Lalibela Rock-Hewn Churches",
    "dateLabel": "1200 CE",
    "year": 1200,
    "era": "medieval",
    "continent": "Africa",
    "url": "/panoramas/1c78f37419f91fe61643ad9b.webp"
  },
  {
    "publicId": "5bcf216ac8a5680709bc3904",
    "title": "Inca Inti Raymi at Cusco",
    "dateLabel": "1430 CE",
    "year": 1430,
    "era": "medieval",
    "continent": "South America",
    "url": "/panoramas/5bcf216ac8a5680709bc3904.webp"
  },
  {
    "publicId": "f820396b182f752f2b91e572",
    "title": "Templo Mayor Dedication",
    "dateLabel": "1487 CE",
    "year": 1487,
    "era": "medieval",
    "continent": "North America",
    "url": "/panoramas/f820396b182f752f2b91e572.webp"
  },
  {
    "publicId": "dd1337274d86a7ff9f4fce62",
    "title": "Mona Lisa in Leonardo's Workshop",
    "dateLabel": "1503 CE",
    "year": 1503,
    "era": "early-modern",
    "continent": "Europe",
    "url": "/panoramas/dd1337274d86a7ff9f4fce62.webp"
  },
  {
    "publicId": "4b60169e6e36a41e3be5233f",
    "title": "St. Peter's Basilica Construction Begins",
    "dateLabel": "1506 CE",
    "year": 1506,
    "era": "early-modern",
    "continent": "Europe",
    "url": "/panoramas/4b60169e6e36a41e3be5233f.webp"
  },
  {
    "publicId": "d8ffe6ae4da5d666b4d3f72f",
    "title": "Magellan Expedition Departs",
    "dateLabel": "1519 CE",
    "year": 1519,
    "era": "early-modern",
    "continent": "Europe",
    "url": "/panoramas/d8ffe6ae4da5d666b4d3f72f.webp"
  },
  {
    "publicId": "28818ab9ecdef27288dc257a",
    "title": "Salem Witch Trials Court",
    "dateLabel": "1692 CE",
    "year": 1692,
    "era": "early-modern",
    "continent": "North America",
    "url": "/panoramas/28818ab9ecdef27288dc257a.webp"
  },
  {
    "publicId": "bb6b77c75af9afa846aa9029",
    "title": "Montgolfier Balloon at Versailles",
    "dateLabel": "1783 CE",
    "year": 1783,
    "era": "early-modern",
    "continent": "Europe",
    "url": "/panoramas/bb6b77c75af9afa846aa9029.webp"
  },
  {
    "publicId": "11546e29f6c022d5135b0ecc",
    "title": "Napoleon's Coronation",
    "dateLabel": "1804 CE",
    "year": 1804,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/11546e29f6c022d5135b0ecc.webp"
  },
  {
    "publicId": "e33688d7ff42c9b70fd1f23d",
    "title": "Grito de Dolores",
    "dateLabel": "1810 CE",
    "year": 1810,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/e33688d7ff42c9b70fd1f23d.webp"
  },
  {
    "publicId": "d4bf18bdee08f4152498fc28",
    "title": "Treaty of Waitangi",
    "dateLabel": "1840 CE",
    "year": 1840,
    "era": "modern",
    "continent": "Oceania",
    "url": "/panoramas/d4bf18bdee08f4152498fc28.webp"
  },
  {
    "publicId": "4958a63eb45c3dd3a447ec72",
    "title": "Stockton and Darlington Railway Opens",
    "dateLabel": "1825 CE",
    "year": 1825,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/4958a63eb45c3dd3a447ec72.webp"
  },
  {
    "publicId": "b03e354b358178e5ba9a770e",
    "title": "California Gold Rush at Sutter's Mill",
    "dateLabel": "1848 CE",
    "year": 1848,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/b03e354b358178e5ba9a770e.webp"
  },
  {
    "publicId": "c2ed27b6b33a664f4f863d8a",
    "title": "Big Ben First Chimes",
    "dateLabel": "1859 CE",
    "year": 1859,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/c2ed27b6b33a664f4f863d8a.webp"
  },
  {
    "publicId": "57076ceaff26ca72fd135a8c",
    "title": "London Underground Opens",
    "dateLabel": "1863 CE",
    "year": 1863,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/57076ceaff26ca72fd135a8c.webp"
  },
  {
    "publicId": "fd0ed9f0ee1db15536373f98",
    "title": "Telephone at the Centennial Exhibition",
    "dateLabel": "1876 CE",
    "year": 1876,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/fd0ed9f0ee1db15536373f98.webp"
  },
  {
    "publicId": "108be060c0867af9f2d7f5e0",
    "title": "Edison Lights Menlo Park",
    "dateLabel": "1879 CE",
    "year": 1879,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/108be060c0867af9f2d7f5e0.webp"
  },
  {
    "publicId": "227f9799d707148650768b1f",
    "title": "Brooklyn Bridge Opens",
    "dateLabel": "1883 CE",
    "year": 1883,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/227f9799d707148650768b1f.webp"
  },
  {
    "publicId": "ad542f26bd747f1c399bc94f",
    "title": "Neuschwanstein Castle Opens",
    "dateLabel": "1886 CE",
    "year": 1886,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/ad542f26bd747f1c399bc94f.webp"
  },
  {
    "publicId": "c43c4694cd498ea82bf7573b",
    "title": "Tower Bridge Opens",
    "dateLabel": "1894 CE",
    "year": 1894,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/c43c4694cd498ea82bf7573b.webp"
  },
  {
    "publicId": "eba99af89d2064744781837f",
    "title": "Ellis Island Immigration Hall",
    "dateLabel": "1907 CE",
    "year": 1907,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/eba99af89d2064744781837f.webp"
  },
  {
    "publicId": "b77e2ef286f0eff43bcb163d",
    "title": "Amundsen Reaches the South Pole",
    "dateLabel": "1911 CE",
    "year": 1911,
    "era": "modern",
    "continent": "Antarctica",
    "url": "/panoramas/b77e2ef286f0eff43bcb163d.webp"
  },
  {
    "publicId": "f88f1818345f216ed73d4355",
    "title": "Ford Moving Assembly Line",
    "dateLabel": "1913 CE",
    "year": 1913,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/f88f1818345f216ed73d4355.webp"
  },
  {
    "publicId": "be31ff25ccb94a818eff3187",
    "title": "Storming of the Winter Palace",
    "dateLabel": "1917 CE",
    "year": 1917,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/be31ff25ccb94a818eff3187.webp"
  },
  {
    "publicId": "44ab2cfe2410509b68dedd77",
    "title": "Hollywood Sign Erected",
    "dateLabel": "1923 CE",
    "year": 1923,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/44ab2cfe2410509b68dedd77.webp"
  },
  {
    "publicId": "4202d937fe475bb65b9b0e4d",
    "title": "Lindbergh Lands in Paris",
    "dateLabel": "1927 CE",
    "year": 1927,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/4202d937fe475bb65b9b0e4d.webp"
  },
  {
    "publicId": "640693484a720f79698179b4",
    "title": "Empire State Building Opens",
    "dateLabel": "1931 CE",
    "year": 1931,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/640693484a720f79698179b4.webp"
  },
  {
    "publicId": "5b8d05d1a02288632746d54e",
    "title": "Sydney Harbour Bridge Opens",
    "dateLabel": "1932 CE",
    "year": 1932,
    "era": "modern",
    "continent": "Oceania",
    "url": "/panoramas/5b8d05d1a02288632746d54e.webp"
  },
  {
    "publicId": "527b5db0e360818761b159e9",
    "title": "V-J Day in Times Square",
    "dateLabel": "1945 CE",
    "year": 1945,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/527b5db0e360818761b159e9.webp"
  },
  {
    "publicId": "98f2395d14b18092e868c8f7",
    "title": "Indian Independence at Red Fort",
    "dateLabel": "1947 CE",
    "year": 1947,
    "era": "modern",
    "continent": "Asia",
    "url": "/panoramas/98f2395d14b18092e868c8f7.webp"
  },
  {
    "publicId": "8efc864f68b34d1ed8956aea",
    "title": "Berlin Airlift at Tempelhof",
    "dateLabel": "1948 CE",
    "year": 1948,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/8efc864f68b34d1ed8956aea.webp"
  },
  {
    "publicId": "d5d80541a6f295ebee86ea21",
    "title": "Elizabeth II Coronation",
    "dateLabel": "1953 CE",
    "year": 1953,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/d5d80541a6f295ebee86ea21.webp"
  },
  {
    "publicId": "ec0f4f0f94a721007fb9e9a2",
    "title": "Disneyland Opening Day",
    "dateLabel": "1955 CE",
    "year": 1955,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/ec0f4f0f94a721007fb9e9a2.webp"
  },
  {
    "publicId": "08efeec03d070b62c809843d",
    "title": "Space Needle at the World's Fair",
    "dateLabel": "1962 CE",
    "year": 1962,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/08efeec03d070b62c809843d.webp"
  },
  {
    "publicId": "aecbeb92f993f18d4ae9e2ea",
    "title": "Tokyo Olympics Opening",
    "dateLabel": "1964 CE",
    "year": 1964,
    "era": "modern",
    "continent": "Asia",
    "url": "/panoramas/aecbeb92f993f18d4ae9e2ea.webp"
  },
  {
    "publicId": "8217a64d2dd3a0f57a29fe4d",
    "title": "Apollo 11 Mission Control",
    "dateLabel": "1969 CE",
    "year": 1969,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/8217a64d2dd3a0f57a29fe4d.webp"
  },
  {
    "publicId": "ab06fde26048ff4bbe7108d8",
    "title": "Sydney Opera House Opens",
    "dateLabel": "1973 CE",
    "year": 1973,
    "era": "modern",
    "continent": "Oceania",
    "url": "/panoramas/ab06fde26048ff4bbe7108d8.webp"
  },
  {
    "publicId": "f1451ae168c0da147b85a71e",
    "title": "CN Tower Opens",
    "dateLabel": "1976 CE",
    "year": 1976,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/f1451ae168c0da147b85a71e.webp"
  },
  {
    "publicId": "e25eda1a2610721cea0cd8d0",
    "title": "Mount St. Helens Eruption",
    "dateLabel": "1980 CE",
    "year": 1980,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/e25eda1a2610721cea0cd8d0.webp"
  },
  {
    "publicId": "8c347e5e0d79c3da5ce3e0f9",
    "title": "Space Shuttle Columbia Launch",
    "dateLabel": "1981 CE",
    "year": 1981,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/8c347e5e0d79c3da5ce3e0f9.webp"
  },
  {
    "publicId": "38808cd986e8dbcaa0c333e7",
    "title": "Live Aid at Wembley",
    "dateLabel": "1985 CE",
    "year": 1985,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/38808cd986e8dbcaa0c333e7.webp"
  },
  {
    "publicId": "3f829c10cfd993538862867f",
    "title": "Fall of the Berlin Wall",
    "dateLabel": "1989 CE",
    "year": 1989,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/3f829c10cfd993538862867f.webp"
  },
  {
    "publicId": "bda589939a8d1935563a7dba",
    "title": "Hong Kong Handover",
    "dateLabel": "1997 CE",
    "year": 1997,
    "era": "modern",
    "continent": "Asia",
    "url": "/panoramas/bda589939a8d1935563a7dba.webp"
  },
  {
    "publicId": "d8f862d62ef2ef5a7bb29b94",
    "title": "Mahabodhi Temple Ashokan Shrine",
    "dateLabel": "250 BCE",
    "year": -250,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/d8f862d62ef2ef5a7bb29b94.webp"
  },
  {
    "publicId": "e25e88ea0628f6f54868b943",
    "title": "Pantheon Dedicated Under Hadrian",
    "dateLabel": "126 CE",
    "year": 126,
    "era": "ancient",
    "continent": "Europe",
    "url": "/panoramas/e25e88ea0628f6f54868b943.webp"
  },
  {
    "publicId": "ec356e856e649d264d7e8755",
    "title": "Sutton Hoo Ship Burial",
    "dateLabel": "625 CE",
    "year": 625,
    "era": "medieval",
    "continent": "Europe",
    "url": "/panoramas/ec356e856e649d264d7e8755.webp"
  },
  {
    "publicId": "2fce69a2bb67b25dbbbfb527",
    "title": "Palenque Temple of the Inscriptions",
    "dateLabel": "692 CE",
    "year": 692,
    "era": "medieval",
    "continent": "North America",
    "url": "/panoramas/2fce69a2bb67b25dbbbfb527.webp"
  },
  {
    "publicId": "00c60bece103e919ffe724c1",
    "title": "Mont Saint-Michel Abbey Rises",
    "dateLabel": "966 CE",
    "year": 966,
    "era": "medieval",
    "continent": "Europe",
    "url": "/panoramas/00c60bece103e919ffe724c1.webp"
  },
  {
    "publicId": "2de6d3d99e72fdc71bcd3b92",
    "title": "Bayeux Tapestry Workshop",
    "dateLabel": "1077 CE",
    "year": 1077,
    "era": "medieval",
    "continent": "Europe",
    "url": "/panoramas/2de6d3d99e72fdc71bcd3b92.webp"
  },
  {
    "publicId": "7811cd39ba0074e64d4e0ecd",
    "title": "White Tower Construction",
    "dateLabel": "1080 CE",
    "year": 1080,
    "era": "medieval",
    "continent": "Europe",
    "url": "/panoramas/7811cd39ba0074e64d4e0ecd.webp"
  },
  {
    "publicId": "5bb0f6b4858dd728edacd4a9",
    "title": "Prague Astronomical Clock Installed",
    "dateLabel": "1410 CE",
    "year": 1410,
    "era": "medieval",
    "continent": "Europe",
    "url": "/panoramas/5bb0f6b4858dd728edacd4a9.webp"
  },
  {
    "publicId": "8c8c3d41b7df8e4d82373807",
    "title": "St Paul Cathedral Completed",
    "dateLabel": "1710 CE",
    "year": 1710,
    "era": "early-modern",
    "continent": "Europe",
    "url": "/panoramas/8c8c3d41b7df8e4d82373807.webp"
  },
  {
    "publicId": "2cf277804728b2e93514c476",
    "title": "El Escorial Completed",
    "dateLabel": "1584 CE",
    "year": 1584,
    "era": "early-modern",
    "continent": "Europe",
    "url": "/panoramas/2cf277804728b2e93514c476.webp"
  },
  {
    "publicId": "39252e815134da59316ac18f",
    "title": "Amsterdam Stock Exchange Opens",
    "dateLabel": "1602 CE",
    "year": 1602,
    "era": "early-modern",
    "continent": "Europe",
    "url": "/panoramas/39252e815134da59316ac18f.webp"
  },
  {
    "publicId": "43fc279320f00e53a2827ac2",
    "title": "Royal Observatory at Greenwich Founded",
    "dateLabel": "1675 CE",
    "year": 1675,
    "era": "early-modern",
    "continent": "Europe",
    "url": "/panoramas/43fc279320f00e53a2827ac2.webp"
  },
  {
    "publicId": "4233d3d05b0e031ca7622666",
    "title": "Boston Massacre",
    "dateLabel": "1770 CE",
    "year": 1770,
    "era": "early-modern",
    "continent": "North America",
    "url": "/panoramas/4233d3d05b0e031ca7622666.webp"
  },
  {
    "publicId": "f4c73256f48bc34e8ebc449a",
    "title": "Washington Crossing the Delaware",
    "dateLabel": "1776 CE",
    "year": 1776,
    "era": "early-modern",
    "continent": "North America",
    "url": "/panoramas/f4c73256f48bc34e8ebc449a.webp"
  },
  {
    "publicId": "85cc70cea1a656f5ef52c08f",
    "title": "Louvre Opens as a Public Museum",
    "dateLabel": "1793 CE",
    "year": 1793,
    "era": "early-modern",
    "continent": "Europe",
    "url": "/panoramas/85cc70cea1a656f5ef52c08f.webp"
  },
  {
    "publicId": "ef5f56259a264903bc7ac6c0",
    "title": "Beethoven Ninth Symphony Premiere",
    "dateLabel": "1824 CE",
    "year": 1824,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/ef5f56259a264903bc7ac6c0.webp"
  },
  {
    "publicId": "84d8a9f79ca758cd4f509569",
    "title": "Liverpool and Manchester Railway Opens",
    "dateLabel": "1830 CE",
    "year": 1830,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/84d8a9f79ca758cd4f509569.webp"
  },
  {
    "publicId": "fbef5a7f7f8e3f8cd0e1a0fb",
    "title": "Commodore Perry Arrives in Edo Bay",
    "dateLabel": "1853 CE",
    "year": 1853,
    "era": "modern",
    "continent": "Asia",
    "url": "/panoramas/fbef5a7f7f8e3f8cd0e1a0fb.webp"
  },
  {
    "publicId": "9d91f225a0a599c731777b20",
    "title": "Florence Nightingale at Scutari Hospital",
    "dateLabel": "1854 CE",
    "year": 1854,
    "era": "modern",
    "continent": "Asia",
    "url": "/panoramas/9d91f225a0a599c731777b20.webp"
  },
  {
    "publicId": "819c2308fb78fe06ba3b9427",
    "title": "Lincoln Assassination at Ford Theatre",
    "dateLabel": "1865 CE",
    "year": 1865,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/819c2308fb78fe06ba3b9427.webp"
  },
  {
    "publicId": "9917bb2dc8e396a426f89223",
    "title": "Chicago Worlds Fair White City",
    "dateLabel": "1893 CE",
    "year": 1893,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/9917bb2dc8e396a426f89223.webp"
  },
  {
    "publicId": "5647fe4db4cb831e6e92b136",
    "title": "Klondike Gold Rush at Chilkoot Pass",
    "dateLabel": "1897 CE",
    "year": 1897,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/5647fe4db4cb831e6e92b136.webp"
  },
  {
    "publicId": "ca455a33f7feed129d780433",
    "title": "First Nobel Prize Ceremony",
    "dateLabel": "1901 CE",
    "year": 1901,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/ca455a33f7feed129d780433.webp"
  },
  {
    "publicId": "8b5ec9aee291909e5c034eac",
    "title": "Archduke Assassination in Sarajevo",
    "dateLabel": "1914 CE",
    "year": 1914,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/8b5ec9aee291909e5c034eac.webp"
  },
  {
    "publicId": "b0a7fb48a834f7118464de23",
    "title": "Wall Street Crash",
    "dateLabel": "1929 CE",
    "year": 1929,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/b0a7fb48a834f7118464de23.webp"
  },
  {
    "publicId": "03ae42fdc26a783b17a41655",
    "title": "BBC Television from Alexandra Palace",
    "dateLabel": "1936 CE",
    "year": 1936,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/03ae42fdc26a783b17a41655.webp"
  },
  {
    "publicId": "26ba01ace7f38349b025c8e3",
    "title": "Bombing of Guernica",
    "dateLabel": "1937 CE",
    "year": 1937,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/26ba01ace7f38349b025c8e3.webp"
  },
  {
    "publicId": "b9cd2999a5e48dfbca6eb228",
    "title": "Munich Agreement",
    "dateLabel": "1938 CE",
    "year": 1938,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/b9cd2999a5e48dfbca6eb228.webp"
  },
  {
    "publicId": "0183416c19da20e722a7bb7a",
    "title": "Nuremberg Trials Begin",
    "dateLabel": "1945 CE",
    "year": 1945,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/0183416c19da20e722a7bb7a.webp"
  },
  {
    "publicId": "175a38284682ec2363db4e03",
    "title": "United Nations Charter Signed",
    "dateLabel": "1945 CE",
    "year": 1945,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/175a38284682ec2363db4e03.webp"
  },
  {
    "publicId": "8462fa0a496feb5ae9d425ed",
    "title": "Dead Sea Scrolls Discovered",
    "dateLabel": "1947 CE",
    "year": 1947,
    "era": "modern",
    "continent": "Asia",
    "url": "/panoramas/8462fa0a496feb5ae9d425ed.webp"
  },
  {
    "publicId": "5d5906d38c901d59194f36d7",
    "title": "NATO Treaty Signed",
    "dateLabel": "1949 CE",
    "year": 1949,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/5d5906d38c901d59194f36d7.webp"
  },
  {
    "publicId": "9dafeb5e5ffe623586ddb3b3",
    "title": "Inchon Landing",
    "dateLabel": "1950 CE",
    "year": 1950,
    "era": "modern",
    "continent": "Asia",
    "url": "/panoramas/9dafeb5e5ffe623586ddb3b3.webp"
  },
  {
    "publicId": "79b4706845270ab5fff3e0e2",
    "title": "Polio Vaccine Announced",
    "dateLabel": "1955 CE",
    "year": 1955,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/79b4706845270ab5fff3e0e2.webp"
  },
  {
    "publicId": "18e060fa47c89ec11fdcc6a8",
    "title": "Hungarian Revolution in Budapest",
    "dateLabel": "1956 CE",
    "year": 1956,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/18e060fa47c89ec11fdcc6a8.webp"
  },
  {
    "publicId": "4241c427b6d5d8bb45d24c65",
    "title": "Cuban Revolution in Havana",
    "dateLabel": "1959 CE",
    "year": 1959,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/4241c427b6d5d8bb45d24c65.webp"
  },
  {
    "publicId": "d755f36dce02e7048399df64",
    "title": "Yuri Gagarin Red Square Parade",
    "dateLabel": "1961 CE",
    "year": 1961,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/d755f36dce02e7048399df64.webp"
  },
  {
    "publicId": "647210804620378751a80af3",
    "title": "Cuban Missile Crisis at the UN",
    "dateLabel": "1962 CE",
    "year": 1962,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/647210804620378751a80af3.webp"
  },
  {
    "publicId": "45fc30095025fdf8be892229",
    "title": "Beatles on Ed Sullivan",
    "dateLabel": "1964 CE",
    "year": 1964,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/45fc30095025fdf8be892229.webp"
  },
  {
    "publicId": "d9a148f9cfa0d10dedc34485",
    "title": "Prague Spring in Wenceslas Square",
    "dateLabel": "1968 CE",
    "year": 1968,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/d9a148f9cfa0d10dedc34485.webp"
  },
  {
    "publicId": "18567cee84be138fcba1bc39",
    "title": "Munich Olympics Opening",
    "dateLabel": "1972 CE",
    "year": 1972,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/18567cee84be138fcba1bc39.webp"
  },
  {
    "publicId": "840f504992908a679e2973c7",
    "title": "Watergate Hearings",
    "dateLabel": "1973 CE",
    "year": 1973,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/840f504992908a679e2973c7.webp"
  },
  {
    "publicId": "e6309733983144d7464d6dae",
    "title": "Iranian Revolution at Azadi Square",
    "dateLabel": "1979 CE",
    "year": 1979,
    "era": "modern",
    "continent": "Asia",
    "url": "/panoramas/e6309733983144d7464d6dae.webp"
  },
  {
    "publicId": "c8e5dddd1cca8103db81179c",
    "title": "Miracle on Ice",
    "dateLabel": "1980 CE",
    "year": 1980,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/c8e5dddd1cca8103db81179c.webp"
  },
  {
    "publicId": "cb9d5bf99971070331ed3ce4",
    "title": "Solidarity at Gdansk Shipyard",
    "dateLabel": "1980 CE",
    "year": 1980,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/cb9d5bf99971070331ed3ce4.webp"
  },
  {
    "publicId": "241e1c141f9c562479cafa04",
    "title": "Good Friday Agreement",
    "dateLabel": "1998 CE",
    "year": 1998,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/241e1c141f9c562479cafa04.webp"
  },
  {
    "publicId": "8aee60ae395d7f2ce0637489",
    "title": "September 11 at the World Trade Center",
    "dateLabel": "2001 CE",
    "year": 2001,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/8aee60ae395d7f2ce0637489.webp"
  },
  {
    "publicId": "aa4f3cb854a938b3ddf43ae8",
    "title": "Barack Obama Inauguration",
    "dateLabel": "2009 CE",
    "year": 2009,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/aa4f3cb854a938b3ddf43ae8.webp"
  },
  {
    "publicId": "22c09dbad7a161204cce980b",
    "title": "Tahrir Square Uprising",
    "dateLabel": "2011 CE",
    "year": 2011,
    "era": "modern",
    "continent": "Africa",
    "url": "/panoramas/22c09dbad7a161204cce980b.webp"
  },
  {
    "publicId": "0e493b60b220c4a2eeb4e232",
    "title": "James Webb Space Telescope Launch",
    "dateLabel": "2021 CE",
    "year": 2021,
    "era": "modern",
    "continent": "South America",
    "url": "/panoramas/0e493b60b220c4a2eeb4e232.webp"
  },
  {
    "publicId": "57b11ea99b36273fd6009bc3",
    "title": "First Public Film Screening",
    "dateLabel": "1895 CE",
    "year": 1895,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/57b11ea99b36273fd6009bc3.webp"
  },
  {
    "publicId": "4a129d42bf44ecb71bac65b9",
    "title": "Kennedy Motorcade at Dealey Plaza",
    "dateLabel": "1963 CE",
    "year": 1963,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/4a129d42bf44ecb71bac65b9.webp"
  },
  {
    "publicId": "7d2e2ccfb4cd7524d97f6b98",
    "title": "Whitechapel Murders Investigation",
    "dateLabel": "1888 CE",
    "year": 1888,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/7d2e2ccfb4cd7524d97f6b98.webp"
  },
  {
    "publicId": "815aa9c5e9d2093fb63f59a1",
    "title": "Roanoke Colony Departure",
    "dateLabel": "1590 CE",
    "year": 1590,
    "era": "early-modern",
    "continent": "North America",
    "url": "/panoramas/815aa9c5e9d2093fb63f59a1.webp"
  },
  {
    "publicId": "d81062cb8718a7f325956b10",
    "title": "Cortes Arrives at the Bay of La Paz",
    "dateLabel": "1535 CE",
    "year": 1535,
    "era": "early-modern",
    "continent": "North America",
    "url": "/panoramas/d81062cb8718a7f325956b10.webp"
  },
  {
    "publicId": "5e855cde85dc02591f9cba60",
    "title": "Christmas Truce on the Western Front",
    "dateLabel": "1914 CE",
    "year": 1914,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/5e855cde85dc02591f9cba60.webp"
  },
  {
    "publicId": "70dbb09a6112ab4bdd68abc3",
    "title": "Cavendish Attacks the Santa Ana at Cabo",
    "dateLabel": "1587 CE",
    "year": 1587,
    "era": "early-modern",
    "continent": "North America",
    "url": "/panoramas/70dbb09a6112ab4bdd68abc3.webp"
  },
  {
    "publicId": "a85b9e424c2d60f12bb20871",
    "title": "Tunguska Event Over the Taiga",
    "dateLabel": "1908 CE",
    "year": 1908,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/a85b9e424c2d60f12bb20871.webp"
  },
  {
    "publicId": "5daca76bef66b9889897ddb6",
    "title": "Mary Celeste Abandonment",
    "dateLabel": "1872 CE",
    "year": 1872,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/5daca76bef66b9889897ddb6.webp"
  },
  {
    "publicId": "43c41d9a7222618c81255e5e",
    "title": "Dyatlov Pass Tent Flight",
    "dateLabel": "1959 CE",
    "year": 1959,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/43c41d9a7222618c81255e5e.webp"
  },
  {
    "publicId": "94b42cfce2bd488986a7f494",
    "title": "Roswell Ranch Debris",
    "dateLabel": "1947 CE",
    "year": 1947,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/94b42cfce2bd488986a7f494.webp"
  },
  {
    "publicId": "24a2a153ff4dfae51a23a2dc",
    "title": "Rasputin Plot at Moika Palace",
    "dateLabel": "1916 CE",
    "year": 1916,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/24a2a153ff4dfae51a23a2dc.webp"
  },
  {
    "publicId": "e6eb137923b29d9c0bf78d74",
    "title": "Trotsky Study at Coyoacan",
    "dateLabel": "1940 CE",
    "year": 1940,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/e6eb137923b29d9c0bf78d74.webp"
  },
  {
    "publicId": "6020a3ff6f6200585b0f2102",
    "title": "Compiegne Railway Carriage Meeting",
    "dateLabel": "1940 CE",
    "year": 1940,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/6020a3ff6f6200585b0f2102.webp"
  },
  {
    "publicId": "371a81f2496e245ad0f00ee4",
    "title": "Constantine Before Milvian Bridge",
    "dateLabel": "312 CE",
    "year": 312,
    "era": "ancient",
    "continent": "Europe",
    "url": "/panoramas/371a81f2496e245ad0f00ee4.webp"
  },
  {
    "publicId": "f2ecf60d8f3b3aa5b097e330",
    "title": "Ugarit During the Bronze Age Collapse",
    "dateLabel": "1177 BCE",
    "year": -1177,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/f2ecf60d8f3b3aa5b097e330.webp"
  },
  {
    "publicId": "b4a78d2e3b562b41daecc82e",
    "title": "Whaleship Essex Rammed",
    "dateLabel": "1820 CE",
    "year": 1820,
    "era": "modern",
    "continent": "South America",
    "url": "/panoramas/b4a78d2e3b562b41daecc82e.webp"
  },
  {
    "publicId": "0ebd48bbfc00c7031a28fcec",
    "title": "Donner Party at Truckee Lake",
    "dateLabel": "1847 CE",
    "year": 1847,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/0ebd48bbfc00c7031a28fcec.webp"
  },
  {
    "publicId": "6f28e7de6c80014c4201e98a",
    "title": "Wow Signal at Big Ear",
    "dateLabel": "1977 CE",
    "year": 1977,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/6f28e7de6c80014c4201e98a.webp"
  },
  {
    "publicId": "b29b424d44ebf93baeee3013",
    "title": "Thera Eruption at Akrotiri",
    "dateLabel": "1620 BCE",
    "year": -1620,
    "era": "ancient",
    "continent": "Europe",
    "url": "/panoramas/b29b424d44ebf93baeee3013.webp"
  },
  {
    "publicId": "a50ba4e00862125f71b346c2",
    "title": "Storegga Tsunami Hits Doggerland",
    "dateLabel": "6200 BCE",
    "year": -6200,
    "era": "ancient",
    "continent": "Europe",
    "url": "/panoramas/a50ba4e00862125f71b346c2.webp"
  },
  {
    "publicId": "99455586d55a2d4dbfb4c816",
    "title": "Strasbourg Dancing Plague",
    "dateLabel": "1518 CE",
    "year": 1518,
    "era": "early-modern",
    "continent": "Europe",
    "url": "/panoramas/99455586d55a2d4dbfb4c816.webp"
  },
  {
    "publicId": "6d6e9d8f019e7b2b87a786f4",
    "title": "Franklin Expedition Abandoned",
    "dateLabel": "1848 CE",
    "year": 1848,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/6d6e9d8f019e7b2b87a786f4.webp"
  },
  {
    "publicId": "42a43d3bc5d866e07601d9e1",
    "title": "Antikythera Shipwreck Storm",
    "dateLabel": "70 BCE",
    "year": -70,
    "era": "ancient",
    "continent": "Europe",
    "url": "/panoramas/42a43d3bc5d866e07601d9e1.webp"
  },
  {
    "publicId": "83cbb8d0e21075de62221af2",
    "title": "Eleusinian Mysteries at Night",
    "dateLabel": "430 BCE",
    "year": -430,
    "era": "ancient",
    "continent": "Europe",
    "url": "/panoramas/83cbb8d0e21075de62221af2.webp"
  },
  {
    "publicId": "a968bbaa6682ccc0966649ee",
    "title": "Washington Defuses the Newburgh Conspiracy",
    "dateLabel": "1783 CE",
    "year": 1783,
    "era": "early-modern",
    "continent": "North America",
    "url": "/panoramas/a968bbaa6682ccc0966649ee.webp"
  },
  {
    "publicId": "3a9bc9872a4798d5c1c45f79",
    "title": "Theodore Roosevelt Milwaukee Speech",
    "dateLabel": "1912 CE",
    "year": 1912,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/3a9bc9872a4798d5c1c45f79.webp"
  },
  {
    "publicId": "31c8de36351abc168bf3d30d",
    "title": "Elizabeth I at Tilbury",
    "dateLabel": "1588 CE",
    "year": 1588,
    "era": "early-modern",
    "continent": "Europe",
    "url": "/panoramas/31c8de36351abc168bf3d30d.webp"
  },
  {
    "publicId": "9993ea4ce9fb87e1029c5105",
    "title": "Churchill on the Air Ministry Roof",
    "dateLabel": "1940 CE",
    "year": 1940,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/9993ea4ce9fb87e1029c5105.webp"
  },
  {
    "publicId": "e0ff3cd76e787afdb1ca8269",
    "title": "Cleopatra Arrives on the Cydnus",
    "dateLabel": "41 BCE",
    "year": -41,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/e0ff3cd76e787afdb1ca8269.webp"
  },
  {
    "publicId": "06a1a2ae362b8017806d9ba1",
    "title": "Alexander Cuts the Gordian Knot",
    "dateLabel": "333 BCE",
    "year": -333,
    "era": "ancient",
    "continent": "Asia",
    "url": "/panoramas/06a1a2ae362b8017806d9ba1.webp"
  },
  {
    "publicId": "8c0a00b6a88c283bdd5b2b38",
    "title": "Caesar Crosses the Rubicon",
    "dateLabel": "49 BCE",
    "year": -49,
    "era": "ancient",
    "continent": "Europe",
    "url": "/panoramas/8c0a00b6a88c283bdd5b2b38.webp"
  },
  {
    "publicId": "4ee46b9bb709c113c9e127cc",
    "title": "FDR Infamy Speech at the Capitol",
    "dateLabel": "1941 CE",
    "year": 1941,
    "era": "modern",
    "continent": "North America",
    "url": "/panoramas/4ee46b9bb709c113c9e127cc.webp"
  },
  {
    "publicId": "2f40ff50ea295a43613ef005",
    "title": "Genghis Khan Proclaimed at Kurultai",
    "dateLabel": "1206 CE",
    "year": 1206,
    "era": "medieval",
    "continent": "Asia",
    "url": "/panoramas/2f40ff50ea295a43613ef005.webp"
  },
  {
    "publicId": "40fd1c5db13b7e23da640fd4",
    "title": "Gorbachev Signs the Soviet Dissolution",
    "dateLabel": "1991 CE",
    "year": 1991,
    "era": "modern",
    "continent": "Europe",
    "url": "/panoramas/40fd1c5db13b7e23da640fd4.webp"
  },
  {
    "publicId": "f42dff6958ca3bb8a7549d9f",
    "title": "Saladin Enters Jerusalem",
    "dateLabel": "1187 CE",
    "year": 1187,
    "era": "medieval",
    "continent": "Asia",
    "url": "/panoramas/f42dff6958ca3bb8a7549d9f.webp"
  }
];

export const SPLASH_PANORAMAS: string[] = [
  "/panoramas/0c9258c1afd337500639aa18.webp",
  "/panoramas/7cf0206494df110859603280.webp",
  "/panoramas/3991bc40dd6f476da5436d7b.webp",
  "/panoramas/9241c3dd79a235dc0a2e7499.webp",
  "/panoramas/d84be71b8e10f68a7cbdd75b.webp",
  "/panoramas/bcb66b1013685cf584e0c6af.webp",
  "/panoramas/3186b56092ced9a0a032b07e.webp",
  "/panoramas/678e202f5bb131fb8de8c560.webp",
  "/panoramas/5daf87590533df7ac2329b90.webp",
  "/panoramas/39d473cc67fb67650801948e.webp",
  "/panoramas/0b0a1122cc632a01c089115e.webp",
  "/panoramas/09baba9f6842116773eac07a.webp"
];

export function publicIdFromSplashUrl(url: string): string {
  return url.match(/\/panoramas\/([^/.]+)\.webp$/)?.[1] ?? "";
}
